/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Clear_Confirmation_DescriptionInputs */

const en_case_payment_clear_confirmation_description = /** @type {(inputs: Case_Payment_Clear_Confirmation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The transaction code and payment date will be removed. The status will be recalculated from the due date.`)
};

const pt_br2_case_payment_clear_confirmation_description = /** @type {(inputs: Case_Payment_Clear_Confirmation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O código da transação e a data do pagamento serão removidos. O status será recalculado pela data de vencimento.`)
};

/**
* | output |
* | --- |
* | "The transaction code and payment date will be removed. The status will be recalculated from the due date." |
*
* @param {Case_Payment_Clear_Confirmation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_clear_confirmation_description = /** @type {((inputs?: Case_Payment_Clear_Confirmation_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Clear_Confirmation_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_clear_confirmation_description(inputs)
	return pt_br2_case_payment_clear_confirmation_description(inputs)
});